var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconEditFill = function SvgIconEditFill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.999996 12.8539V15.5539C0.998789 15.6128 1.00941 15.6713 1.03123 15.726C1.05306 15.7807 1.08564 15.8305 1.12704 15.8723C1.16844 15.9142 1.21783 15.9473 1.27228 15.9698C1.32672 15.9922 1.38511 16.0035 1.444 16.0029H4.144C4.20225 16.0037 4.26002 15.9923 4.31359 15.9694C4.36715 15.9465 4.41532 15.9126 4.455 15.8699L14.16 6.16992L10.83 2.83792L1.13 12.5379C1.08713 12.5793 1.05321 12.6291 1.03034 12.6841C1.00746 12.7392 0.996115 12.7983 0.996996 12.8579L0.999996 12.8539ZM16.74 3.59292C16.8224 3.51072 16.8878 3.41306 16.9324 3.30556C16.977 3.19806 16.9999 3.08281 16.9999 2.96642C16.9999 2.85003 16.977 2.73479 16.9324 2.62728C16.8878 2.51978 16.8224 2.42213 16.74 2.33992L14.66 0.259922C14.5778 0.177529 14.4801 0.11216 14.3726 0.0675592C14.2651 0.022958 14.1499 0 14.0335 0C13.9171 0 13.8019 0.022958 13.6944 0.0675592C13.5869 0.11216 13.4892 0.177529 13.407 0.259922L11.781 1.88692L15.114 5.21992L16.74 3.59292Z",
    fill: "#F37924"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconEditFill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_edit_fill.71201049.svg";
export { ForwardRef as ReactComponent };